import { render, staticRenderFns } from "./HelpDialog.vue?vue&type=template&id=81d3d670&"
import script from "./HelpDialog.vue?vue&type=script&lang=js&"
export * from "./HelpDialog.vue?vue&type=script&lang=js&"
import style0 from "./HelpDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HelpDialog.vue"
export default component.exports